import { CaptureChatLastUserInteractionDefinition } from "@super-real/types";
import { getCallable } from "../../Firebase/helpers/getCallable";

export const captureChatLastUserInteractionCallable = getCallable(
  CaptureChatLastUserInteractionDefinition
);
